import { cacheIsCurrent } from './cacheIsCurrent';

type CacheValue = {
  expiresAt: string;
  value: any;
};

export class LocalStorageCache {
  static TIME_TO_EXPIRE_CACHE = 900000; // 15 minutes

  /**
   * hashing function to convert any string into a numeric value, taken from java
   * https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
   */
  static hash = (value: string): string => {
    if (!value) return '';
    return Array.from(value)
      .reduce((hash, char) => {
        const newHash = (hash << 5) - hash + char.charCodeAt(0);
        return newHash & newHash;
      }, 0)
      .toString();
  };

  static get = (key: string, expiry?: number): any | undefined => {
    const cachedValue = window.localStorage.getItem(key);
    if (!cachedValue) return;

    try {
      const parsedValue: CacheValue = JSON.parse(cachedValue);
      if (!cacheIsCurrent(parsedValue.expiresAt, expiry || LocalStorageCache.TIME_TO_EXPIRE_CACHE)) return;

      return parsedValue.value;
    } catch (e) {
      return;
    }
  };

  static set = (key: string, value: any) => {
    const finalValue: CacheValue = {
      expiresAt: Date.now().toString(),
      value,
    };

    window.localStorage.setItem(key, JSON.stringify(finalValue));
  };
}
